import { api } from './index';

export interface Requisition {
  id: string;
  requisitionNumber: string;
  title: string;
  description: string;
  department: string;
  category: 'GOODS' | 'SERVICES';
  priority: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
  status: 'DRAFT' | 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED' | 'CONVERTED_TO_RFQ';
  requestedBy: {
    id: string;
    fullName: string;
    email: string;
  };
  approvedBy?: {
    id: string;
    fullName: string;
    email: string;
  };
  approvedAt?: string;
  approvalComments?: string;
  items: RequisitionItem[];
  rfq?: {
    id: string;
    rfqNumber: string;
    status: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface RequisitionItem {
  id: string;
  itemName: string;
  description?: string;
  quantity: number;
  unit: string;
  estimatedPrice?: number;
  specifications?: Record<string, any>;
  order: number;
}

export interface CreateRequisitionDto {
  title: string;
  description: string;
  department: string;
  category: 'GOODS' | 'SERVICES';
  priority?: 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';
  items: Omit<RequisitionItem, 'id'>[];
}

export interface RequisitionFilters {
  status?: Requisition['status'];
  category?: Requisition['category'];
  department?: string;
  priority?: Requisition['priority'];
  search?: string;
}

export const requisitionsApi = {
  list: (filters?: RequisitionFilters): Promise<Requisition[]> =>
    api.get('/requisitions', { params: filters }).then((res) => res.data),

  get: (id: string): Promise<Requisition> =>
    api.get(`/requisitions/${id}`).then((res) => res.data),

  create: (data: CreateRequisitionDto): Promise<Requisition> =>
    api.post('/requisitions', data).then((res) => res.data),

  update: (id: string, data: Partial<CreateRequisitionDto>): Promise<Requisition> =>
    api.patch(`/requisitions/${id}`, data).then((res) => res.data),

  submitForApproval: (id: string): Promise<Requisition> =>
    api.post(`/requisitions/${id}/submit-approval`).then((res) => res.data),

  approve: (id: string, comments?: string): Promise<Requisition> =>
    api.post(`/requisitions/${id}/approve`, { comments }).then((res) => res.data),

  reject: (id: string, comments: string): Promise<Requisition> =>
    api.post(`/requisitions/${id}/reject`, { comments }).then((res) => res.data),

  convertToRFQ: (id: string): Promise<Requisition> =>
    api.post(`/requisitions/${id}/convert-to-rfq`).then((res) => res.data),
};

